import db from '@/plugins/dexie';
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from 'moment-timezone';
import { geraDataNuvem } from '../geradata';

import { testarConexaoApi } from '../isonline';
import { SetupEnvioLocal } from '../atualizalocal';

function extraiBearerToken(tokenString) {
  if (!tokenString) return '';
  try {
    const tokenObj = JSON.parse(tokenString);
    return tokenObj?.token || tokenObj;
  } catch (e) {
    return tokenString;
  }
}

export default async function enviaItemMovimentacaoVeiculo(idParentLocal = null) {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) {
    console.warn('enviaItemMovimentacaoVeiculo: Sem token de autenticação');
    return;
  }
  const bearerToken = extraiBearerToken(tokenString);

  let houveAlteracao = false;

  let itens = await db.itemmovimentacaoveiculo.toArray();

  // 1. Resolve vínculo com a movimentação pai caso ainda não esteja atualizado
  for (const item of itens) {
    let idNuvemPai = item.imvidmovimentacaonuvem || null;
    let idNumeroPai = null;

    if (item.imvidmovimentacaoveiculo || item.movimentacaouuid) {
      const idBusca = Number(item.imvidmovimentacaoveiculo);
      let pai = await db.movimentacaoveiculo.get(Number.isNaN(idBusca) ? item.imvidmovimentacaoveiculo : idBusca);
      if (!pai && (typeof item.imvidmovimentacaoveiculo === 'string' || item.movimentacaouuid)) {
        const u = item.movimentacaouuid || item.imvidmovimentacaoveiculo;
        pai = await db.movimentacaoveiculo.filter((m) => m.uuid === u || m.movuuid === u).first();
      }
      if (pai) {
        if (pai.movidnuvem) {
          idNuvemPai = pai.movidnuvem;
        }
        if (typeof pai.movidmovimentacaoveiculo === 'number' && !Number.isNaN(pai.movidmovimentacaoveiculo)) {
          idNumeroPai = pai.movidmovimentacaoveiculo;
        }
      } else if (typeof item.imvidmovimentacaoveiculo === 'number') {
        idNumeroPai = item.imvidmovimentacaoveiculo;
      }
    }

    const precisaAtualizarNuvem = Boolean(idNuvemPai && item.imvidmovimentacaonuvem !== idNuvemPai);
    const precisaAtualizarNumero = Boolean(idNumeroPai !== null && item.imvidmovimentacaoveiculo !== idNumeroPai);
    if (precisaAtualizarNuvem || precisaAtualizarNumero) {
      const updates = {};
      if (precisaAtualizarNuvem) {
        item.imvidmovimentacaonuvem = idNuvemPai;
        updates.imvidmovimentacaonuvem = idNuvemPai;
      }
      if (precisaAtualizarNumero) {
        item.imvidmovimentacaoveiculo = idNumeroPai;
        updates.imvidmovimentacaoveiculo = idNumeroPai;
      }
      await db.itemmovimentacaoveiculo.update(item.id, updates);
    }
  }

  if (idParentLocal) {
    const parentNum = Number(idParentLocal);
    const parentRecord = await db.movimentacaoveiculo.get(Number.isNaN(parentNum) ? idParentLocal : parentNum);

    itens = itens.filter((i) => {
      if (i.imvdeletar) return false;
      const matchLocal = String(i.imvidmovimentacaoveiculo) === String(idParentLocal)
        || (parentRecord?.uuid && (i.imvidmovimentacaoveiculo === parentRecord.uuid || i.movimentacaouuid === parentRecord.uuid));
      const matchNuvem = Boolean(parentRecord?.movidnuvem && i.imvidmovimentacaonuvem === parentRecord.movidnuvem);
      const matchNumPai = Boolean(
        typeof parentRecord?.movidmovimentacaoveiculo === 'number'
        && !Number.isNaN(parentRecord.movidmovimentacaoveiculo)
        && Number(i.imvidmovimentacaoveiculo) === parentRecord.movidmovimentacaoveiculo,
      );
      if (!matchLocal && !matchNuvem && !matchNumPai) return false;

      return !i.imvidnuvem || !i.imvdatanuvem || (i.imvdataalteracao && i.imvdatanuvem && moment(i.imvdataalteracao).isAfter(moment(i.imvdatanuvem)));
    });
  } else {
    itens = itens.filter((i) => !i.imvdeletar && (!i.imvidnuvem || !i.imvdatanuvem || (i.imvdataalteracao && i.imvdatanuvem && moment(i.imvdataalteracao).isAfter(moment(i.imvdatanuvem)))));
  }

  if (itens.length === 0) return;

  for (const item of itens) {
    let aguardandoPai = false;
    let idNuvemPai = item.imvidmovimentacaonuvem || null;
    let idNumeroPai = null;

    if (item.imvidmovimentacaoveiculo || item.movimentacaouuid) {
      const idBusca = Number(item.imvidmovimentacaoveiculo);
      let pai = await db.movimentacaoveiculo.get(Number.isNaN(idBusca) ? item.imvidmovimentacaoveiculo : idBusca);
      if (!pai && (typeof item.imvidmovimentacaoveiculo === 'string' || item.movimentacaouuid)) {
        const u = item.movimentacaouuid || item.imvidmovimentacaoveiculo;
        pai = await db.movimentacaoveiculo.filter((m) => m.uuid === u || m.movuuid === u).first();
      }
      if (pai) {
        if (pai.movidnuvem) {
          idNuvemPai = pai.movidnuvem;
        }
        if (typeof pai.movidmovimentacaoveiculo === 'number' && !Number.isNaN(pai.movidmovimentacaoveiculo)) {
          idNumeroPai = pai.movidmovimentacaoveiculo;
        }
      } else if (typeof item.imvidmovimentacaoveiculo === 'number') {
        idNumeroPai = item.imvidmovimentacaoveiculo;
      }
    }

    if (!idNuvemPai && !idNumeroPai) {
      console.warn('Item aguardando envio da movimentação pai para a nuvem:', item);
      aguardandoPai = true;
    }

    if (!aguardandoPai) {
      if (item.imvidnuvem) {
        // console.log('put itemmovimentacaoveiculo - ', item);
        const payload = {
          id: item.imvidnuvem,
          imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo || null,
          imvidmovimentacaoveiculo: idNumeroPai,
          imvidmovimentacaonuvem: idNuvemPai,
          imvtiposervico: item.imvtiposervico,
          imvidproduto: item.imvidproduto,
          imvdescricaoproduto: item.imvdescricaoproduto,
          imvunidadedemedida: item.imvunidadedemedida,
          imvquantidade: item.imvquantidade,
          imvprecounitario: item.imvprecounitario,
          imvidlocalarmazenamento: item.imvidlocalarmazenamento || null,
          imvobservacao: item.imvobservacao || '',
          imvvalortotal: item.imvvalortotal,
          imvdataalteracao: geraDataNuvem(),
          imviditemmovimentacaoveiculonuvem: item.imviditemmovimentacaoveiculonuvem || null,
        };

        try {
          const res = await apirecebimentoweb.put(`/itemmovimentacaoveiculo/${item.imvidnuvem}`, payload, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          });
          const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
          const alteracao = geraDataNuvem(dadosResp?.imvdataalteracao || dadosResp?.updated || new Date());
          const idItemFinal = dadosResp?.imviditemmovimentacaoveiculo
            || dadosResp?.id
            || item.imviditemmovimentacaoveiculo
            || null;
          const idMovimentacaoFinal = (typeof dadosResp?.imvidmovimentacaoveiculo === 'number')
            ? dadosResp.imvidmovimentacaoveiculo
            : idNumeroPai;
          await db.itemmovimentacaoveiculo.update(item.id, {
            imvidmovimentacaonuvem: idNuvemPai,
            ...(idItemFinal ? { imviditemmovimentacaoveiculo: idItemFinal } : {}),
            ...(idMovimentacaoFinal !== null && idMovimentacaoFinal !== undefined ? { imvidmovimentacaoveiculo: idMovimentacaoFinal } : {}),
            imvdataalteracao: alteracao,
            imvdatanuvem: alteracao,
            imvenviado: 1,
            enviado: 1,
          });
          houveAlteracao = true;
        } catch (err) {
          console.error('Erro ao atualizar itemmovimentacaoveiculo:', err.response?.data || err.message || err);
        }
      } else {
        // console.log('post itemmovimentacaoveiculo - ', item);
        const payload = {
          imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo || null,
          imvidmovimentacaoveiculo: idNumeroPai,
          imvidmovimentacaonuvem: idNuvemPai,
          imvtiposervico: item.imvtiposervico,
          imvidproduto: item.imvidproduto,
          imvdescricaoproduto: item.imvdescricaoproduto,
          imvunidadedemedida: item.imvunidadedemedida,
          imvquantidade: item.imvquantidade,
          imvprecounitario: item.imvprecounitario,
          imvidlocalarmazenamento: item.imvidlocalarmazenamento || null,
          imvobservacao: item.imvobservacao || '',
          imvvalortotal: item.imvvalortotal,
          imvdataalteracao: item.imvdataalteracao ? geraDataNuvem(item.imvdataalteracao) : geraDataNuvem(),
          imviditemmovimentacaoveiculonuvem: item.imviditemmovimentacaoveiculonuvem || null,
        };

        try {
          const res = await apirecebimentoweb.post('/itemmovimentacaoveiculo', payload, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          });
          const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
          const alteracao = geraDataNuvem(dadosResp?.imvdataalteracao || dadosResp?.created || new Date());
          const idNuvemItem = dadosResp?.id
            || dadosResp?.imvidnuvem
            || dadosResp?.imviditemmovimentacaoveiculo
            || dadosResp?.insertId;
          const idItemFinal = dadosResp?.imviditemmovimentacaoveiculo
            || dadosResp?.id
            || item.imviditemmovimentacaoveiculo
            || null;
          const idMovimentacaoFinal = (typeof dadosResp?.imvidmovimentacaoveiculo === 'number')
            ? dadosResp.imvidmovimentacaoveiculo
            : idNumeroPai;

          await db.itemmovimentacaoveiculo.update(item.id, {
            imvidnuvem: idNuvemItem,
            imviditemmovimentacaoveiculo: idItemFinal,
            imvidmovimentacaonuvem: idNuvemPai,
            ...(idMovimentacaoFinal !== null && idMovimentacaoFinal !== undefined ? { imvidmovimentacaoveiculo: idMovimentacaoFinal } : {}),
            imvdataalteracao: alteracao,
            imvdatanuvem: alteracao,
            imvenviado: 1,
            enviado: 1,
          });
          houveAlteracao = true;
        } catch (err) {
          console.error('Erro ao cadastrar itemmovimentacaoveiculo:', err.response?.data || err.message || err);
        }
      }
    }
  }

  if (houveAlteracao) {
    try {
      await SetupEnvioLocal({ silent: true });
    } catch (err) {
      console.warn('Aviso: Falha ao executar SetupEnvioLocal pós-envio de itens de movimentação:', err);
    }
  }
}

export async function deletaItemMovimentacaoVeiculo(idParentLocal = null) {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) return;
  const bearerToken = extraiBearerToken(tokenString);

  let registros = await db.itemmovimentacaoveiculo.toArray();
  if (idParentLocal) {
    const parentNum = Number(idParentLocal);
    const parentRecord = await db.movimentacaoveiculo.get(Number.isNaN(parentNum) ? idParentLocal : parentNum);
    registros = registros.filter((i) => {
      if (!i.imvdeletar) return false;
      const matchLocal = String(i.imvidmovimentacaoveiculo) === String(idParentLocal)
        || (parentRecord?.uuid && (i.imvidmovimentacaoveiculo === parentRecord.uuid || i.movimentacaouuid === parentRecord.uuid));
      const matchNuvem = Boolean(parentRecord?.movidnuvem && i.imvidmovimentacaonuvem === parentRecord.movidnuvem);
      const matchNumPai = Boolean(
        typeof parentRecord?.movidmovimentacaoveiculo === 'number'
        && !Number.isNaN(parentRecord.movidmovimentacaoveiculo)
        && Number(i.imvidmovimentacaoveiculo) === parentRecord.movidmovimentacaoveiculo,
      );
      return matchLocal || matchNuvem || matchNumPai;
    });
  } else {
    registros = registros.filter((i) => i.imvdeletar);
  }

  for (const item of registros) {
    if (item.imvidnuvem) {
      try {
        await apirecebimentoweb.delete(`/itemmovimentacaoveiculo/${item.imvidnuvem}`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
      } catch (err) {
        console.error('Erro ao deletar itemmovimentacaoveiculo na API:', err.response?.data || err.message || err);
      }
    }
    await db.itemmovimentacaoveiculo.delete(item.id);
  }
}
